export enum CreateSetCardActionTypes {
  CREATING = 'set-cards/CREATING',
  CREATED = 'set-cards/CREATED',
}
